import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { IRootStore } from '../models/root'
import CircularProgressBar from './CircularProgressBar'

interface ICardProps {
  shouldUpdate: boolean
}

interface InjectedProps extends ICardProps {
  store: IRootStore
}

@inject('store')
@observer
class CardProgress extends React.Component<ICardProps> {
  get injected() {
    return this.props as InjectedProps
  }

  public render() {
    const { store } = this.injected
    const { shouldUpdate } = this.props;

    return (
      <div className={'card__progress card__progress--visible'}>
        <CircularProgressBar
          fillColor={'#000'}
          percentage={shouldUpdate ? store.player.progressPercentage * 100 : 0}
          diameter={60}
          strokeWidth={7}
        />
      </div>
    )
  }
}

export default CardProgress



// WEBPACK FOOTER //
// ./src/components/CardProgress.tsx